// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopupAlert_modal__qdaH7","content":"PopupAlert_content__1YyD9","modalOverlay":"PopupAlert_modalOverlay__wu4Dx","title":"PopupAlert_title__3YZvr"};